import { Icon, IconDefinitions } from '../../../../components';
import { ActiveConfiguration } from '../../../../data/entities';

interface ActiveConfigurationCardProps {
  activeConfiguration: ActiveConfiguration | null | undefined;
  isOnline: boolean;
}

export function ActiveConfigurationCard({ activeConfiguration, isOnline }: ActiveConfigurationCardProps) {
  if (!activeConfiguration) {
    return (
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body p-4">
          <h5 className="mb-4 d-flex align-items-center">
            <Icon iconName={IconDefinitions.settings} className="me-2 text-primary" />
            Active Configuration
          </h5>
          <div className="text-center text-muted py-4">
            <Icon iconName={IconDefinitions.settings} style={{ fontSize: '2.5rem' }} className="mb-3 opacity-25" />
            {isOnline ? (
              <>
                <p className="mb-0">Waiting for configuration data...</p>
                <small>This will populate once the device sends its first heartbeat.</small>
              </>
            ) : (
              <>
                <p className="mb-0">No configuration data available.</p>
                <small>The device is offline and has not sent any data yet.</small>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm border-0 mb-4">
      <div className="card-body p-4">
        <h5 className="mb-4 d-flex align-items-center">
          <Icon iconName={IconDefinitions.settings} className="me-2 text-primary" />
          Active Configuration
        </h5>

        <div className="row g-4">
          <div className="col-sm-6">
            <div className="text-center">
              <Icon
                iconName={IconDefinitions.clock}
                style={{ fontSize: '2rem' }}
                className="text-primary"
              />
              <div className="text-muted small mt-2 mb-1">Heartbeat Interval</div>
              <h5 className="mb-0">{activeConfiguration.heartbeatIntervalSeconds}s</h5>
              <small className="text-muted">How often the agent checks in</small>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="text-center">
              <Icon
                iconName={IconDefinitions.hashtag}
                style={{ fontSize: '2rem' }}
                className="text-primary"
              />
              <div className="text-muted small mt-2 mb-1">Target Import Rows</div>
              <h5 className="mb-0">{activeConfiguration.targetImportRows}</h5>
              <small className="text-muted">Target rows per import</small>
            </div>
          </div>

          {activeConfiguration.rollingAverageWindowSize != null && (
            <div className="col-sm-6">
              <div className="text-center">
                <Icon
                  iconName={IconDefinitions.chartLineUp}
                  style={{ fontSize: '2rem' }}
                  className="text-primary"
                />
                <div className="text-muted small mt-2 mb-1">Rolling Avg Window</div>
                <h5 className="mb-0">{activeConfiguration.rollingAverageWindowSize}</h5>
                <small className="text-muted">FLW points averaged for live deviation</small>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
